import { render, staticRenderFns } from "./Dosimetrie.vue?vue&type=template&id=512597df&"
import script from "./Dosimetrie.vue?vue&type=script&lang=js&"
export * from "./Dosimetrie.vue?vue&type=script&lang=js&"
import style0 from "./Dosimetrie.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports